import React from "react";
import { Toolbar as RaToolbar, SaveButton } from "react-admin";

const Toolbar = (props) => (
  <RaToolbar {...props} style={{ paddingLeft: 16 }}>
    <SaveButton label="ra.action.save" redirect={false} submitOnEnter={true} />
  </RaToolbar>
);
export default Toolbar;
